export default "__VITE_ASSET__xiuyum79__"